import React, {useContext, createContext, useState} from "react";
import {useNavigate} from "react-router-dom";

import {jwtDecode} from 'jwt-decode';
import * as moment from 'moment';

import {useAuth0} from "@auth0/auth0-react";
import APIClient from "../../client";
import config from "../../config.js";


const AuthContext = createContext();
const client = new APIClient(config);


const AuthProvider = ({children}) => {
    const {logout} = useAuth0();

    const [user, setUser] = useState(localStorage.getItem("user") || null);
    const [userData, setUserData] = useState({
        email: null,
        is_active: null,
        is_superuser: null,
        is_fund_viewer: null,
        is_opportunity_viewer: null,
        first_name: null,
        last_name: null,
        idp_id: null,
        id: null,
        created_at: null
    })
    const [token, setToken] = useState(localStorage.getItem("site") || "");
    const navigate = useNavigate();

    const fetchUser = async (token) => {
        try {
            client.fetchUser(token).then((data) => {
                localStorage.setItem('site', token);

                setUser({...user, data});

                setUserData({
                    ...userData,
                    email: data.email,
                    first_name: data.first_name,
                    is_active: data.is_active,
                    is_superuser: data.is_superuser,
                    is_fund_viewer: data.is_fund_viewer,
                    is_opportunity_viewer: data.is_opportunity_viewer,
                });

                localStorage.setItem("user", JSON.stringify({
                    'email': data.email,
                    'first_name': data.first_name,
                    'is_active': data.is_active,
                    'is_superuser': data.is_superuser,
                    'is_fund_viewer': data.is_fund_viewer,
                    'is_opportunity_viewer': data.is_opportunity_viewer,
                }));

                navigate("/platform");
            }).catch((err) => {
                console.error(err);
            });
        } catch (err) {
            console.error(err);
        }
    };

    const validateToken = () => {
        const tokenString = localStorage.getItem('site');

        if (tokenString) {
            const token = tokenString;
            const decodedAccessToken = jwtDecode(token);
            const isAccessTokenValid =
                moment.unix(decodedAccessToken.exp).toDate() > new Date();

            if (!isAccessTokenValid) {
                localStorage.removeItem('site');
                localStorage.removeItem('user');
                navigate("/");
            }
            else {
                let user = JSON.parse(localStorage.getItem('user'));
                setUserData({
                    ...userData,
                    email: user.email,
                    first_name: user.first_name,
                    is_active: user.is_active,
                    is_superuser: user.is_superuser,
                    is_fund_viewer: user.is_fund_viewer,
                    is_opportunity_viewer: user.is_opportunity_viewer,
                });
            }
        } else {
            navigate("/");
        }

    };

    const logOut = () => {
        setUser(null);
        setToken("");
        setUserData({
            email: null,
            is_active: null,
            is_superuser: null,
            is_fund_viewer: null,
            is_opportunity_viewer: null,
            first_name: null,
            last_name: null,
            idp_id: null,
            id: null,
            created_at: null
        });
        localStorage.removeItem("site");
        localStorage.removeItem("user");
        logout();
        navigate("/");
    };

    return (
        <AuthContext.Provider value={{token, user, userData, fetchUser, validateToken, logOut}}>
            {children}
        </AuthContext.Provider>
    );

};

export default AuthProvider;

export const useAuth = () => {
    return useContext(AuthContext);
};